import { render, staticRenderFns } from "./UserPasswordSettings.vue?vue&type=template&id=21b7cbbc&"
import script from "./UserPasswordSettings.vue?vue&type=script&lang=js&"
export * from "./UserPasswordSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserPasswordSettings.vue"
export default component.exports